<template>
	<div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="Filtros">
                <div class="col-auto">
                    <label class="col-form-label text-primary">Año:</label>
                </div>
                <div class="col-auto">
                    <select @change="Lista(); GetEventos()" v-model="Filtro.Anio" class="form-select form-control-search">
                        <!-- <option value="2023">2023-TESTING</option> -->
                        <option v-for="(item,index) in FiltroAnios" :key="index" :value="item">{{item}}</option>
                    </select>
                </div>
                <div class="col-auto">
                    <label class="col-form-label text-primary">Mes:</label>
                </div>
                <div class="col-auto">
                    <select @change="Lista()" v-model="Filtro.Mes" class="form-select form-control-search">
                        <option v-for="(item,index) in FiltroMeses" :key="index" :value="item.Mes">{{item.Nombre}}</option>
                    </select>
                </div>
                <div class="col-auto">
                    <label class="col-form-label text-primary">Ejecutivo:</label>
                </div>
                <div class="col-auto">
                    <select @change="Lista()" v-model="Filtro.IdEjecutivo" class="form-select form-control-search">
                        <option value="">Todos</option>
                        <option v-for="(item,index) in ListaEjecutivos" :key="index" :value="item.IdUsuario">{{item.Nombre}}</option>
                    </select>
                </div>
            </template>

            <template slot="AntTabla">
                <div class="form-group row px-4 my-3">
                    <div class="col-12">
                        <div class="form-group row">
                            <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                <div class="card text-white bg-secondary h-100">
                                    <div class="card-body">
                                        <div class="card-body-icon">
                                            <i class="fa fa-fw fa-calendar"></i>
                                        </div>
                                        <h5 class="text-white">
                                            Eventos Pendientes
                                        </h5>
                                    </div>
                                    <div @click="FiltrarTipoEvento('Pendientes')" class="card-footer clearfix small z-index-1 cursor-pointer">
                                        <span style="float:left;font-size:15px;">Total Pendientes:</span>
                                        <span style="float:right; width:30px">
                                            <div class="circNum">
                                                <p>{{ Eventos.Pendientes }}</p>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                <div @click="FiltrarTipoEvento('Confirmados')" class="card text-white bg-success h-100">
                                    <div class="card-body">
                                        <div class="card-body-icon">
                                            <i class="fa fa-fw fa-calendar"></i>
                                        </div>
                                        <h5 class="text-white">
                                            Eventos Confirmados
                                        </h5>
                                    </div>
                                    <div class="card-footer clearfix small z-index-1 cursor-pointer">
                                        <span style="float:left;font-size:15px;">Total Confirmados:</span>
                                        <span style="float:right; width:30px">
                                            <div class="circNum">
                                                <p>{{ Eventos.Confirmados }}</p>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                <div @click="FiltrarTipoEvento('Atendidos')" class="card text-white bg-info h-100">
                                    <div class="card-body">
                                        <div class="card-body-icon">
                                            <i class="fa fa-fw fa-calendar"></i>
                                        </div>
                                        <h5 class="text-white">
                                            Eventos Atendidos
                                        </h5>
                                    </div>
                                    <div class="card-footer clearfix small z-index-1 cursor-pointer">
                                        <span style="float:left;font-size:15px;">Total Atendidos:</span>
                                        <span style="float:right; width:30px">
                                            <div class="circNum">
                                                <p>{{ Eventos.Atendidos }}</p>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                <div @click="FiltrarTipoEvento('Descartados')" class="card text-white bg-danger h-100">
                                    <div class="card-body">
                                        <div class="card-body-icon">
                                            <i class="fa fa-fw fa-calendar"></i>
                                        </div>
                                        <h5 class="text-white">
                                            Eventos Descartados
                                        </h5>
                                    </div>
                                    <div class="card-footer clearfix small z-index-1 cursor-pointer">
                                        <span style="float:left;font-size:15px;">Total Descartados:</span>
                                        <span style="float:right; width:30px">
                                            <div class="circNum">
                                                <p>{{ Eventos.Descartados }}</p>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
   
                        <div class="row w-100 align-items-center justify-content-center">
                            <div class="btn-group align-items-center justify-content-center w-100 w-md-100 w-lg-100 w-xl-60" role="group" aria-label="Grupo de Etapas">
                                <label class="col-3 btn px-1 btn-info" title="Prospecto" for="btncheck1"><span class="badge bg-white text-dark rounded-pill">1</span> Prospecto</label>
                                <label class="col-3 btn px-1 text-white bg-primary" title="Cotización" for="btncheck2"><span class="badge bg-white text-dark rounded-pill">2</span> Cotización</label>
                                <label class="col-3 btn px-1 btn-success text-truncate" title="Confirmacion Cotización" for="btncheck3"><span class="badge bg-white text-dark rounded-pill">3</span> Confirmacion Cotización</label>
                                <label class="col-3 btn px-1 btn-danger text-truncate" title="Encuesta y facturación" for="btncheck4"><span class="badge bg-white text-dark rounded-pill">4</span> Encuesta y facturación</label>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
			<template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Folio</th>
                <th :class="StyleTh">Fecha</th>
                <th :class="StyleTh">Cliente</th>
                <th v-if="Filtro.TipoEvento=='Descartados'" :class="StyleTh">Personal que descartó</th>
                <th :class="StyleTh">Estatus</th>
                <th v-if="Filtro.TipoEvento=='Descartados'" :class="StyleTh">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
					<td><h6 :class="StylePr">{{lista.Folio}}</h6></td>
                    <td><p :class="StyleTd">{{lista.FechaBoda}}</p></td>
                    <td><p :class="StyleTd">{{lista.Nombres}}</p></td>
                    <td v-if="Filtro.TipoEvento=='Descartados'"><p :class="StyleTd">{{lista.personal_descarto}}</p></td>
                    <td><p :class="StyleTd"> <span class="badge" :class="lista.BadgeClass">{{lista.TextoEstatus}}</span></p></td>
                    <td v-if="Filtro.TipoEvento=='Descartados'">
                        <button @click="VerClienteDescartado(lista.IdDescarteCliente,lista.personal_descarto)" class="btn btn-link text-primary px-3 mb-0 mr-1" type="button"><i aria-hidden="true" class="fas fa-eye text-primary me-2"></i>Ver Detalle</button>
                    </td>
				</tr>
                <CSinRegistros class="bg-red" :pContIF="ListaArrayRows.length" :pColspan="6"></CSinRegistros>
			</template>
		</CList>

		<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
                <CLoader :pConfigLoad="ConfigLoadDescarte">
                    <template slot="BodyFormLoad">
                        <div class="container-fluid">
                            <div class="form-group row">
                                <div class="col-12">
                                    <label class="form-label" for="Cliente">Cliente:</label>
                                    <input  class="form-control" type="text" :value="ObjDescarte.NombreCliente" name="Cliente" id="Cliente" readonly disabled>
                                </div>
                                <div class="col-12">
                                    <label class="form-label" for="Tipo">Tipo de descarte:</label>
                                    <input  class="form-control" type="text" :value="ObjDescarte.Tipo" name="Tipo" id="Tipo" readonly disabled>
                                </div>
                                <div class="col-6">
                                    <label class="form-label" for="PersonalDescarto">Personal que descartó:</label>
                                    <input  class="form-control" type="text" :value="ObjDescarte.PersonalDescarto" name="PersonalDescarto" id="PersonalDescarto" readonly disabled>
                                </div>
                                <div class="col-6">
                                    <label class="form-label" for="Fecha">Fecha de descarte:</label>
                                    <input  class="form-control" type="text" :value="ObjDescarte.FechaDescarte" name="Fecha" id="Fecha" readonly disabled>
                                </div>
                                <div class="col-12">
                                    <label class="form-label" for="Motivo">Motivo:</label>
                                    <textarea class="form-control"  name="Motivo" id="Motivo" cols="30" rows="4" :value="ObjDescarte.MotivoDescarte" readonly></textarea>
                                    <!-- <textarea  class="form-control" type="text" name="Motivo" :value="ObjDescarte.MotivoDescarte" id="Motivo" readonly disabled></textarea> -->
                                </div>
                            </div>
                        </div>
                    </template>
                </CLoader>
			</template>
		</CModal>
	</div>
</template>

<script>

import moment from 'moment';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionRendimientoEvento';

export default {
    name: 'ListaRendimientoEvento',
    props: ['sFiltros','pOrigen'],
    components: {},
    data() {
        return {
            ConfigList:{
                Title: 'Rendimiento Eventos',
                BtnNewShow:false,
                ShowYear: false,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                ShowMonth: false,
                BtnReturnShow: true,
                TitleFirst: '',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Mes:'',
                Placeholder: 'Buscar..',
                TipoEvento:'',
                Anio: moment(new Date()).format('YYYY'),
                IdEjecutivo:'',
            },
            ConfigModal:{
                ModalTitle: "Cliente descartado",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                ShowBtnSave:false,
                EmitSeccion: EmitEjecuta,
            },
            ListaEjecutivos:[],
            Eventos:{
                Pendientes:0,
                Confirmados:0,
                Atendidos:0,
                Descartados:0,
            },
            ObjDescarte:{
                NombreCliente:'',
                PersonalDescarto:'',
                FechaDescarte:'',
                MotivoDescarte:'',
                Tipo:'',
            },
            ConfigLoadDescarte:{
                ShowLoader:false,
                ClassLoad:true,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],
            FiltroAnios:[],
            FiltroMeses: [
                {Mes:'',Nombre:'Todos'},
                {Mes:'01',Nombre:'Enero'},
                {Mes:'02',Nombre:'Febrero'},
                {Mes:'03',Nombre:'Marzo'},
                {Mes:'04',Nombre:'Abril'},
                {Mes:'05',Nombre:'Mayo'},
                {Mes:'06',Nombre:'Junio'},
                {Mes:'07',Nombre:'Julio'},
                {Mes:'08',Nombre:'Agosto'},
                {Mes:'09',Nombre:'Septiembre'},
                {Mes:'10',Nombre:'Octubre'},
                {Mes:'11',Nombre:'Noviembre'},
                {Mes:'12',Nombre:'Diciembre'},
            ],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("rendimientoEventos",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    TipoEvento: this.Filtro.TipoEvento,
                    Mes: this.Filtro.Mes,
                    Anio: this.Filtro.Anio,
                    IdEjecutivo: this.Filtro.IdEjecutivo,
                    Pag: this.Filtro.Pagina,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.ListaArrayRows.forEach(elem => {
                    switch (elem.Estatus) {
                        case '0':
                            elem['BadgeClass'] = 'bg-info';
                            elem['TextoEstatus'] = 'Prospecto';
                            break;
                        case '3':
                            elem['BadgeClass'] = 'bg-success';
                            elem['TextoEstatus'] = 'Confirm. Cotización';
                            break;
                        case '4':
                            elem['BadgeClass'] = 'bg-danger';
                            elem['TextoEstatus'] = 'Encuesta y Factura';
                            break;
                    
                        default:
                            elem['BadgeClass'] = 'bg-primary';
                            elem['TextoEstatus'] = 'Cotizacion';
                            break;
                    }
                })
                //this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Regresar(){
            this.$router.push({name:'panelSubMenus', params:{}});
        },
        GetEventos(){
            this.$http.get('rendimientoEventosCount',{params:{
                Anio:this.Filtro.Anio,
            }}).then((res)=> {
                this.Eventos = res.data.data;
            })
        },
        FiltrarTipoEvento(TipoEvento){
            this.Filtro.TipoEvento = TipoEvento;
            this.Filtro.Mes = '';
            this.Filtro.IdEjecutivo = '';
            this.Lista();
        },
        GetCmbEjecutivos(){
            this.$http.get('users',{
                params:{
                    simple:true,
                    TipoUsuario:'US'
                }
            }).then((res)=> {
                this.ListaEjecutivos = res.data.data;
            })
        },
        SetAnios(){
            let AnioIncial='2024';
            let AnioSig = moment(new Date()).add('1','year').format('YYYY');
            for(let a = AnioIncial; a <= AnioSig; a++){
                this.FiltroAnios.push(a);
            };
        },
        VerClienteDescartado(IdDescarteCliente,personal_descarto){
            this.bus.$emit('NewModal_'+EmitEjecuta);
            this.ConfigLoadDescarte.ShowLoader = true;
            this.ObjDescarte ={
                NombreCliente:'',
                PersonalDescarto:'',
                FechaDescarte:'',
                MotivoDescarte:'',
                Tipo:'',
            },
            this.$http.get('informacionDescarteCliente/'+IdDescarteCliente
            ).then((res)=>{
                this.ObjDescarte = res.data.data;
                this.ObjDescarte.PersonalDescarto = personal_descarto;
            }).catch(err => console.error(err)
            ).finally(()=>{
                this.ConfigLoadDescarte.ShowLoader = false;
            })
        },
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.SetAnios();
        this.GetCmbEjecutivos();
        this.GetEventos();
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
